import React, { ReactElement, useEffect } from 'react';
import { twMerge } from 'tailwind-merge';
import { Text } from '../';
import { DOWNLOAD_GRID_ORDER, PLATFORMS } from '../../data/platforms';
import { FOCUS_RING } from '../button/variants';
import { trackLinks } from '../../utilities';

type IProps = {
  /** Display name of the platform to leave out — "Sketch", "Figma". */
  excludedPlatform: string;
};

/*
  Was nine hand-written anchors and nine hand-written trackLinks calls, each
  identical apart from an id, href, image and label — and carrying a second
  copy of the download URLs that had already drifted from the other two.

  The anchors also had no focus styles at all, so they were the one group of
  links on the site that showed nothing on keyboard focus.
*/

const LOGO =
  'h-15 w-17.5 transition-all group-hover:rotate-[5deg] group-hover:drop-shadow-[0px_8px_12px_rgba(0,0,0,0.16)] group-hover:group-odd:scale-[1.02] group-hover:group-odd:rotate-[-4deg]';

export default function FreeDownloadPlatforms({
  excludedPlatform,
}: IProps): ReactElement {
  const platforms = DOWNLOAD_GRID_ORDER.map((slug) => PLATFORMS[slug]).filter(
    (p) => p.name !== excludedPlatform
  );

  useEffect(() => {
    platforms.forEach((p) =>
      trackLinks(`#download--${p.trackId}`, 'Download clicked', {
        platform: p.name,
      })
    );
  }, [platforms]);

  return (
    <div className="mx-auto flex max-w-2xl flex-col items-center">
      <div className="suite-platforms mt-12 flex flex-wrap justify-between gap-6">
        {platforms.map((p) => (
          <a
            key={p.slug}
            id={`download--${p.trackId}`}
            target="_blank"
            rel="noopener noreferrer"
            href={p.downloadUrl}
            title="(opens in new tab)"
            className={twMerge(
              'group flex flex-col items-center font-normal no-underline',
              FOCUS_RING
            )}>
            <img className={LOGO} alt="" src={p.iconSrc} />
            <Text level="semibold" className="mt-4">
              {`Stark for ${p.name}`}
            </Text>
          </a>
        ))}
      </div>
    </div>
  );
}
